import * as Report from '../constants/report.constant'
import { DayTrainingLog } from '../interfaces/day-training-log'
import { ReportLog } from '../interfaces/reoprt-log'

export interface State {
  logs: DayTrainingLog[]
  reportLog: ReportLog
  details: DayTrainingLog
  isFetching: Boolean
}

export const initialState: State = {
  logs: null,
  reportLog: null,
  details: null,
  isFetching: false,
}

const report = (state: any = initialState, action: any) => {
  switch (action.type) {
    case Report.GET_REPORT_LOGS:
      return {
        ...state,
        isFetching: true,
        reportLog: action.payload,
      }
    case Report.GET_REPORT_LOGS_SUCCESS:
      return {
        ...state,
        isFetching: false,
      }
    case Report.GET_REPORT_LOG_DETAILS:
      return {
        ...state,
        isFetching: true,
        details: action.payload,
      }
    case Report.GET_REPORT_LOG_DETAILS_SUCCESS:
      return {
        ...state,
        isFetching: false,
      }
    default:
      return state
  }
}

export default report



// WEBPACK FOOTER //
// ./src/reducers/report.reducer.ts